import React from 'react';

const Navbar = () =>{
    return(
        <>
        <div className = "navbar">
        <img id = "logo" alt= "Google-Cloud" src= "https://events.withgoogle.com/media/ade087df/img/microsite-wsx/logos/google-cloud.png"/>
         </div>
        </>
    );
};

export default Navbar;